// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 12.5em;
  height: 18em;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.3s;
  position: relative;
  padding: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.image-container {
  position: relative;
  width: 100%;
  height: 150px;
}

.tag {
  position: absolute;
  top: -8px;
  right: 0;
  background-color: #b51f25;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 0.75em;
  font-family: "Fivo Sans Italic", sans-serif;
}

.card:hover:not(.no-hover) {
  transform: scale(1.05);
}

.card.no-hover .card-expanded {
  display: none;
}

.card.selected {
  border: 2px solid #66a53d;
}

.card img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.card h3 {
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1em;
  margin: 0.5em 1em;
}

.card .top-specs {
  font-size: 0.8em;
  font-family: "IBM Plex Sans", sans-serif;
  color: #666;
  margin: 1em 1em;
}

.card-expanded {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9); /* Slightly transparent background */
  border-top: 1px solid #ccc;
  z-index: 10;
  padding: 0.5em;
  text-align: left;
  display: none;
  max-height: 10em;
  transition: all 0.3s ease;
  overflow-y: auto;
  white-space: pre-wrap;
}

.card-expanded h3 {
  text-align: center;
}

.card-expanded p {
  text-align: left;
}

.card:hover .card-expanded {
  display: block; /* Show on hover */
  height: 100px; /* Adjust as needed */
}

.card-expanded .spec-key {
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 0.7em;
}

.card-expanded .spec-value {
  font-size: 0.7em;
  font-family: "Fivo Sans Light", sans-serif;
}

.checkmark {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #66a53d;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Other CSS rules remain the same */

/* Additional CSS for .step-container, .loading-spinner, etc. */
.step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.loading-spinner {
  border: 1em solid #f3f3f3;
  border-top: 1em solid #3498db;
  border-radius: 50%;
  width: 7.5em;
  height: 7.5em;
  animation: spin 2s linear infinite;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.market-title,
.environment-title,
.moduleClass-title,
.module-title,
.driver-title,
.accessories-title {
  font-size: 1.5em;
  font-family: "Fivo Sans Regular", sans-serif;
  color: #333;
  margin: 1em 0 1em 0;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 2em;
  justify-content: center;
  margin-bottom: 20px;
  width: 100%;
  max-width: 1200px; /* Adjust the max-width as needed */
}

.filters label {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  font-family: "Fivo Sans Regular", sans-serif;
  flex: 1 1; /* Allow inputs to grow and fill available space */
  min-width: 150px; /* Set a minimum width for each filter */
  max-width: 200px;
}

.filters select,
.filters input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: "Fivo Sans Regular", sans-serif;
  color: #999;
  flex: 1 1;
  min-width: -moz-fit-content;
  min-width: fit-content;
  max-width: 200px;
  padding: 10px;
  font-size: 1em;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 0.5em;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-top: 0.7em;
}

.filters select:focus,
.filters input:focus {
  border-color: #007bff;
  outline: none;
}

.results-info {
  margin: 10px 0;
  font-size: 1em;
  color: #333;
}

.results-info p {
  font-family: "Fivo Sans Medium", sans-serif;
  text-align: center;
}

.card-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin: 2em 0.6em;
  max-width: 1500px; /* Adjust the max width as needed */
}

.card-section h3 {
  font-size: 1.1em;
  font-family: "Fivo Sans Regular", sans-serif;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}
ca .pagination {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.pagination button {
  /* background-color: #b51f25; */
  border: none;
  color: white;
  padding: 10px 15px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 5px;
}

.pagination button:hover {
  background-color: #9e1c20;
}

.pagination button.active {
  background-color: #66a53d;
  font-weight: bold;
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin-top: 20px;
  position: relative;
}

.nav-button {
  background-color: #b51f25; /* Adura LSC red */
  border: none;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.nav-button:hover {
  background-color: #9e1c20; /* Darker shade for hover */
}

.nav-button:disabled {
  background-color: #cccccc; /* Disabled color */
  cursor: not-allowed;
}

.prev {
  position: absolute;
  left: 0;
}

.next {
  position: absolute;
  right: 0;
}

@media (max-width: 600px) {
  .nav-button {
    padding: 8px 16px;
    font-size: 14px;
  }
}

button {
  background-color: #b51f25; /* Adura LSC red */
  border: none;
  color: white;
  padding: 10px 20px;
  margin: 10px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #9e1c20; /* Darker shade for hover */
}

/* Additional PCB card styles */
.pcb-card {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: calc(20% - 1.25em); /* 20% of the container width minus the gap */
  height: 16.25em;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s, border 0.2s;
  position: relative;
}

.pcb-card:hover {
  transform: scale(1.05);
}

.pcb-card.selected {
  border: 2px solid #66a53d;
}

.pcb-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.pcb-card h3 {
  font-size: 1.2em;
  margin: 10px 0;
}

.pcb-card p {
  font-size: 0.9em;
  padding: 0 10px;
}

.view-toggle {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-bottom: 20px;
  align-items: center;
  width: 100%;
  max-width: 1200px;
}

.icon-button {
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  padding: 5px;
  color: #333;
  transition: color 0.3s;
}

.icon-button:hover {
  color: white;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 20px;
}

.header-title {
  flex: 1 1;
  text-align: left;
  font-size: 1.5em;
  font-family: "Fivo Sans Regular", sans-serif;
}

.button-container {
  display: flex;
  gap: 10px;
}
.accessories-text {
  font-family: "Fivo Sans Light", sans-serif;
  margin: 0 1em 0 1em;
}
.open-modal-button {
  background: #d23038; /* Adura LSC red */
  border: none;
  color: #fff;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 0.9em;
  transition: background-color 0.3s ease;
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 0.8em;
  align-items: flex-end;
}
.open-modal-button:hover {
  background: #b51f25; /* Darker shade for hover */
  text-decoration: none;
}
.nav-button-save,
.nav-button-excel {
  background-color: #b51f25; /* Adura LSC red */
  border: none;
  color: white;
  padding: 0.625em 1.25em;
  cursor: pointer;
  border-radius: 25px;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  font-family: "Fivo Sans Medium", sans-serif;
}

.nav-button-save .icon,
.nav-button-excel .icon {
  margin-top: 0.2em;
  margin-bottom: 0.3em;
  margin-left: 0.5em;
  font-size: 1.4em;
}

.nav-button-save:hover,
.nav-button-excel:hover {
  background-color: #9e1c20; /* Darker shade for hover */
}

.selections-title {
  font-size: 1.5em;
  font-family: "Fivo Sans Regular", sans-serif;
  color: #333;
  margin: 1em 0.5em;
}

.pipe-separator {
  font-size: 1.2em;
  color: #333;
  padding: 0 0px;
}

.summary {
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}
.datasheet-container {
  width: 100%;
  max-width: 75em;
  margin: 0 auto;
  padding: 0 1em;
}
.datasheet-table-container {
  width: 100%;
  display: flex;
  overflow-x: auto;
  justify-content: center;
  margin-top: 0.5em;
}

.datasheet-table {
  width: 100%;
  min-width: 62.5em;
  border-collapse: collapse;
  margin-bottom: 1em;
  font-size: 0.8em;
}
.datasheet-table-title {
  font-size: 1.2em;
  font-family: "Fivo Sans Regular", sans-serif;
  color: #333;
  margin: 1em 0.5em;
  text-align: left;
}
.datasheet-table th {
  text-transform: capitalize;
  font-family: "Fivo Sans Medium", sans-serif;
  border: 1px solid #ccc;
  padding: 0.5em;
  text-align: left;
  background-color: #b51f25;
  color: white;
}

.datasheet-table td {
  border: 1px solid #ccc;
  text-align: left;
  padding: 0.5em;
  font-family: "Fivo Sans Regular", sans-serif;
}

.datasheet-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.datasheet-table tr:nth-child(odd) {
  background-color: #e6e6e6;
}

.datasheet-table .specs-column {
  white-space: pre-wrap;
  padding: 0.8em;
  line-height: 1.5;
}

@media (max-width: 769px) {
  .datasheet-table-container {
    font-size: 0.7em;
    min-width: 80%;
  }

  .datasheet-table {
    min-width: 200px;
  }

  .card-container {
    max-width: 100%;
    justify-content: center;
    align-items: center;
  }

  .filters {
    flex-direction: column;
    align-items: center;
  }

  .nav-button {
    padding: 8px 16px;
    font-size: 14px;
  }

  .datasheet-table th,
  .datasheet-table td {
    font-size: 1em;
  }

  .datasheet-table th {
    text-align: center;
    background-color: #b51f25;
  }

  .datasheet-table td {
    text-align: center;
  }

  .header-title {
    font-size: 1.2em;
    font-family: "Fivo Sans Bold", sans-serif;
  }

  .view-toggle {
    font-size: 0.5em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SystemCreator/Card.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oCAAoC,EAAE,oCAAoC;EAC1E,0BAA0B;EAC1B,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oCAAoC;;AAEpC,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;EAME,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,SAAO,EAAE,kDAAkD;EAC3D,gBAAgB,EAAE,wCAAwC;EAC1D,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,WAAW;EACX,SAAO;EACP,2BAAsB;EAAtB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB,EAAE,6CAA6C;EACxE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,mBAAmB,EAAE,kBAAkB;EACvC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;EACtC,2CAA2C;EAC3C,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB,EAAE,2BAA2B;EAChD,qBAAqB;AACvB;AACA;;EAEE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".card {\n  background-color: white;\n  border-radius: 15px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  width: 12.5em;\n  height: 18em;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.3s;\n  position: relative;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.image-container {\n  position: relative;\n  width: 100%;\n  height: 150px;\n}\n\n.tag {\n  position: absolute;\n  top: -8px;\n  right: 0;\n  background-color: #b51f25;\n  color: white;\n  padding: 2px 5px;\n  border-radius: 3px;\n  font-size: 0.75em;\n  font-family: \"Fivo Sans Italic\", sans-serif;\n}\n\n.card:hover:not(.no-hover) {\n  transform: scale(1.05);\n}\n\n.card.no-hover .card-expanded {\n  display: none;\n}\n\n.card.selected {\n  border: 2px solid #66a53d;\n}\n\n.card img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.card h3 {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1em;\n  margin: 0.5em 1em;\n}\n\n.card .top-specs {\n  font-size: 0.8em;\n  font-family: \"IBM Plex Sans\", sans-serif;\n  color: #666;\n  margin: 1em 1em;\n}\n\n.card-expanded {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.9); /* Slightly transparent background */\n  border-top: 1px solid #ccc;\n  z-index: 10;\n  padding: 0.5em;\n  text-align: left;\n  display: none;\n  max-height: 10em;\n  transition: all 0.3s ease;\n  overflow-y: auto;\n  white-space: pre-wrap;\n}\n\n.card-expanded h3 {\n  text-align: center;\n}\n\n.card-expanded p {\n  text-align: left;\n}\n\n.card:hover .card-expanded {\n  display: block; /* Show on hover */\n  height: 100px; /* Adjust as needed */\n}\n\n.card-expanded .spec-key {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 0.7em;\n}\n\n.card-expanded .spec-value {\n  font-size: 0.7em;\n  font-family: \"Fivo Sans Light\", sans-serif;\n}\n\n.checkmark {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #66a53d;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Other CSS rules remain the same */\n\n/* Additional CSS for .step-container, .loading-spinner, etc. */\n.step-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.loading-spinner {\n  border: 1em solid #f3f3f3;\n  border-top: 1em solid #3498db;\n  border-radius: 50%;\n  width: 7.5em;\n  height: 7.5em;\n  animation: spin 2s linear infinite;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.market-title,\n.environment-title,\n.moduleClass-title,\n.module-title,\n.driver-title,\n.accessories-title {\n  font-size: 1.5em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  color: #333;\n  margin: 1em 0 1em 0;\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2em;\n  justify-content: center;\n  margin-bottom: 20px;\n  width: 100%;\n  max-width: 1200px; /* Adjust the max-width as needed */\n}\n\n.filters label {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  flex: 1; /* Allow inputs to grow and fill available space */\n  min-width: 150px; /* Set a minimum width for each filter */\n  max-width: 200px;\n}\n\n.filters select,\n.filters input {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  color: #999;\n  flex: 1;\n  min-width: fit-content;\n  max-width: 200px;\n  padding: 10px;\n  font-size: 1em;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 0.5em;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  margin-top: 0.7em;\n}\n\n.filters select:focus,\n.filters input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.results-info {\n  margin: 10px 0;\n  font-size: 1em;\n  color: #333;\n}\n\n.results-info p {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  text-align: center;\n}\n\n.card-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin: 2em 0.6em;\n  max-width: 1500px; /* Adjust the max width as needed */\n}\n\n.card-section h3 {\n  font-size: 1.1em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: center;\n}\nca .pagination {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.pagination button {\n  /* background-color: #b51f25; */\n  border: none;\n  color: white;\n  padding: 10px 15px;\n  margin: 0 5px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.pagination button:hover {\n  background-color: #9e1c20;\n}\n\n.pagination button.active {\n  background-color: #66a53d;\n  font-weight: bold;\n}\n\n.navigation-buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 600px;\n  margin-top: 20px;\n  position: relative;\n}\n\n.nav-button {\n  background-color: #b51f25; /* Adura LSC red */\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.nav-button:hover {\n  background-color: #9e1c20; /* Darker shade for hover */\n}\n\n.nav-button:disabled {\n  background-color: #cccccc; /* Disabled color */\n  cursor: not-allowed;\n}\n\n.prev {\n  position: absolute;\n  left: 0;\n}\n\n.next {\n  position: absolute;\n  right: 0;\n}\n\n@media (max-width: 600px) {\n  .nav-button {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}\n\nbutton {\n  background-color: #b51f25; /* Adura LSC red */\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  margin: 10px;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n}\n\nbutton:hover {\n  background-color: #9e1c20; /* Darker shade for hover */\n}\n\n/* Additional PCB card styles */\n.pcb-card {\n  background-color: white;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  width: calc(20% - 1.25em); /* 20% of the container width minus the gap */\n  height: 16.25em;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.2s, border 0.2s;\n  position: relative;\n}\n\n.pcb-card:hover {\n  transform: scale(1.05);\n}\n\n.pcb-card.selected {\n  border: 2px solid #66a53d;\n}\n\n.pcb-card img {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n}\n\n.pcb-card h3 {\n  font-size: 1.2em;\n  margin: 10px 0;\n}\n\n.pcb-card p {\n  font-size: 0.9em;\n  padding: 0 10px;\n}\n\n.view-toggle {\n  display: flex;\n  justify-content: flex-end;\n  gap: 5px;\n  margin-bottom: 20px;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.icon-button {\n  background: none;\n  border: none;\n  font-size: 1.5em;\n  cursor: pointer;\n  padding: 5px;\n  color: #333;\n  transition: color 0.3s;\n}\n\n.icon-button:hover {\n  color: white;\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  margin-bottom: 20px;\n}\n\n.header-title {\n  flex: 1;\n  text-align: left;\n  font-size: 1.5em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n}\n\n.button-container {\n  display: flex;\n  gap: 10px;\n}\n.accessories-text {\n  font-family: \"Fivo Sans Light\", sans-serif;\n  margin: 0 1em 0 1em;\n}\n.open-modal-button {\n  background: #d23038; /* Adura LSC red */\n  border: none;\n  color: #fff;\n  padding: 10px 20px;\n  cursor: pointer;\n  border-radius: 0.9em;\n  transition: background-color 0.3s ease;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 0.8em;\n  align-items: flex-end;\n}\n.open-modal-button:hover {\n  background: #b51f25; /* Darker shade for hover */\n  text-decoration: none;\n}\n.nav-button-save,\n.nav-button-excel {\n  background-color: #b51f25; /* Adura LSC red */\n  border: none;\n  color: white;\n  padding: 0.625em 1.25em;\n  cursor: pointer;\n  border-radius: 25px;\n  transition: background-color 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1em;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n\n.nav-button-save .icon,\n.nav-button-excel .icon {\n  margin-top: 0.2em;\n  margin-bottom: 0.3em;\n  margin-left: 0.5em;\n  font-size: 1.4em;\n}\n\n.nav-button-save:hover,\n.nav-button-excel:hover {\n  background-color: #9e1c20; /* Darker shade for hover */\n}\n\n.selections-title {\n  font-size: 1.5em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  color: #333;\n  margin: 1em 0.5em;\n}\n\n.pipe-separator {\n  font-size: 1.2em;\n  color: #333;\n  padding: 0 0px;\n}\n\n.summary {\n  margin-bottom: 20px;\n  justify-content: center;\n  align-items: center;\n}\n.datasheet-container {\n  width: 100%;\n  max-width: 75em;\n  margin: 0 auto;\n  padding: 0 1em;\n}\n.datasheet-table-container {\n  width: 100%;\n  display: flex;\n  overflow-x: auto;\n  justify-content: center;\n  margin-top: 0.5em;\n}\n\n.datasheet-table {\n  width: 100%;\n  min-width: 62.5em;\n  border-collapse: collapse;\n  margin-bottom: 1em;\n  font-size: 0.8em;\n}\n.datasheet-table-title {\n  font-size: 1.2em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  color: #333;\n  margin: 1em 0.5em;\n  text-align: left;\n}\n.datasheet-table th {\n  text-transform: capitalize;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  border: 1px solid #ccc;\n  padding: 0.5em;\n  text-align: left;\n  background-color: #b51f25;\n  color: white;\n}\n\n.datasheet-table td {\n  border: 1px solid #ccc;\n  text-align: left;\n  padding: 0.5em;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n}\n\n.datasheet-table tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.datasheet-table tr:nth-child(odd) {\n  background-color: #e6e6e6;\n}\n\n.datasheet-table .specs-column {\n  white-space: pre-wrap;\n  padding: 0.8em;\n  line-height: 1.5;\n}\n\n@media (max-width: 769px) {\n  .datasheet-table-container {\n    font-size: 0.7em;\n    min-width: 80%;\n  }\n\n  .datasheet-table {\n    min-width: 200px;\n  }\n\n  .card-container {\n    max-width: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .filters {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .nav-button {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n\n  .datasheet-table th,\n  .datasheet-table td {\n    font-size: 1em;\n  }\n\n  .datasheet-table th {\n    text-align: center;\n    background-color: #b51f25;\n  }\n\n  .datasheet-table td {\n    text-align: center;\n  }\n\n  .header-title {\n    font-size: 1.2em;\n    font-family: \"Fivo Sans Bold\", sans-serif;\n  }\n\n  .view-toggle {\n    font-size: 0.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
